export default function phone (value) {
    let phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
    if (phoneRegex.test(value)) {
        return value.replace(phoneRegex, '($1) $2-$3')
    } else {
        // Invalid phone number
        return ''
    }
}
